module.exports = __webpack_public_path__ + "assets/img/effective3.47254ad3.png";